import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Product = () => {
  const [products, setProducts] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('product_name');
  const [tableSortType, setTableSortType] = useState('ascending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const searchInputRef = useRef(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));


  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const requestProducts = {};
      const fetchProducts = await jwtFetch(config.ENDPOINT + 'get/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProducts)
      });
      const responseProducts = await fetchProducts.json();
      if (responseProducts.status === 200) {
        for (let i in responseProducts.data) {
          let searchData = String(responseProducts.data[i].product_name ?? '').toLowerCase();
          searchData += String(responseProducts.data[i].category_name ?? '').toLowerCase();
          searchData += String(responseProducts.data[i].subcategory_name ?? '').toLowerCase();
          searchData += String(responseProducts.data[i].product_type ?? '').toLowerCase();
          searchData += String(responseProducts.data[i].product_currency ?? '').toLowerCase();
          responseProducts.data[i].search = searchData;
        }
        setProducts(responseProducts.data);
        setIsLoadingPage(false);
      } else {
        alert(responseProducts.message);
      }
    } catch (error) {
      console.error('Error in getProducts:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="product-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="product" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Product List</div>
                      <div className="btn-group" role="group">
                        <button className="btn bg-gold" type="button"><i className="bi bi-box me-1" /> Products</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product/category'}><i className="bi bi-tag me-1" /> Categories</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/product/category/subcategory'}><i className="bi bi-tags me-1" /> Subcategories</button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus />
                      </div>
                      {crmUser.user_level === 'Admin' && (
                        <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/product/add'}><i className="bi bi-plus-circle me-1" /> Add</button>
                      )}
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {products && products.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('product_name')}>Name {tableSortBy === 'product_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer" onClick={() => sortTable('product_type')}>Type {tableSortBy === 'product_type' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-end" onClick={() => sortTable('product_currency')}>Currency {tableSortBy === 'product_currency' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('product_status')}>Status {tableSortBy === 'product_status' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(products, tableSortBy, tableSortType === 'ascending')
                              .filter(product => product.search.includes(tableSearch.toLowerCase()))
                              .map((product, p) =>
                                <tr key={"product-" + p}>
                                  <td valign="middle">{p + 1}</td>
                                  <td valign="middle">{product.product_name}</td>
                                  <td valign="middle" align="center">{product.product_type}</td>
                                  <td valign="middle" align="center">{product.product_currency}</td>
                                  <td valign="middle" align="center"><span className={"badge bg-" + (product.product_status === 'Active' ? 'success' : 'danger')}>{product.product_status}</span></td>
                                  <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/product/detail/' + product.id_product}><i className="bi bi-eye" /></button></td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;

